import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen3 from "../../../images/modulo12/patio.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad10.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[12];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[11].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[11].path}`,
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[13].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[13].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>Mira la ilustración.</li>
          </ul>
          <img src={Imagen3} alt="Vecindario" className="img-fluid" />
        </div>
        <div className="col-lg-10 col-12">
          <ul className="mb-4">
            <li>
              Fíjate: ¿qué hacen los niños? ¿Qué hacen las niñas? ¿Qué hacen los
              profesores? ¿Qué hacen las profesoras?
              <textarea className="form-control mb-2" rows={4} />
            </li>
            <li>
              Piensa: ¿cómo podrías cambiar la escena para que la imagen muestre
              igualdad entre hombres y mujeres?
              <textarea className="form-control mb-2" rows={4} />
            </li>
            <li>
              Haz un nuevo dibujo, con todos los cambios, y cuélgalo en una
              pared.{" "}
            </li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Mira la ilustración. Pida que observen la
            ilustración y pregunte:
            <ul>
              <li>
                <i>
                  “¿Qué lugar observamos en la imagen? (Posible respuesta: Se
                  trata del patio de una escuela. Probablemente sea el recreo o
                  el momento previo a que se inicien las clases). ¿Quiénes
                  aparecen en la imagen? (Posible respuesta: niñas, niños,
                  maestros y maestras).”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la segunda indicación: Fíjate: ¿qué hacen los niños? ¿Qué hacen
            las niñas? ¿Qué hacen los profesores? ¿Qué hacen las profesoras? Dé
            un tiempo. Luego, recoja sus respuestas:
            <ul>
              <li>
                <i>
                  “¿Qué hacen los niños en la imagen? (Posible respuesta: Los
                  niños están jugando fútbol en una cancha grande. Uno de ellos
                  está recibiendo un plato de comida). - ¿Qué hacen las niñas en
                  la imagen? (Posible respuesta: Un grupo de niñas está jugando
                  vóley en una cancha pequeña. Dos niñas están limpiando el
                  salón. Otras niñas están ayudando a preparar el desayuno
                  escolar y una de ellas le está sirviendo comida a un niño. -
                  ¿Qué hacen los profesores? (Posible respuesta: Están
                  conversando en el patio). - ¿Qué hacen las profesoras?
                  (Posible respuesta: Preparan el desayuno escolar).
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: Piensa: ¿cómo podrías cambiar la escena
            para que la imagen muestre igualdad entre hombres y mujeres?
          </li>
          <li>
            Recoja las respuestas. La idea es que se den cuenta de situaciones cargadas
            de prejuicios que ocurren frecuentemente en su escuela. Por ejemplo:
            de las tareas de barrer el salón o preparar el desayuno escolar se
            encargan solamente a las alumnas.
          </li>
          <li>
            Lea la última indicación: Haz un nuevo dibujo, con todos los
            cambios, y cuélgalo en una pared. La idea es que en el nuevo dibujo
            se refleje una situación más igualitaria, donde los niños también
            limpien, donde las niñas puedan usar la cancha grande y no solo la
            pequeña para jugar, donde los maestros participen en la preparación
            del desayuno o almuerzo escolar, etc.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
